/**
 * Pointer/keyboard activity → control visibility.
 */
export function createActivityMonitor(options) {
  options = options || {};
  var idleMs = options.idleMs != null ? options.idleMs : 3000;
  var timer = null;
  var active = true;
  var listeners = [];

  function notify() {
    for (var i = 0; i < listeners.length; i++) {
      try {
        listeners[i](active);
      } catch (e) {
        /* ignore */
      }
    }
  }

  function setActive(next) {
    if (active === next) {
      return;
    }
    active = next;
    notify();
  }

  function bump() {
    setActive(true);
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      setActive(false);
    }, idleMs);
  }

  function bind(el) {
    if (!el) {
      return function () {};
    }
    var events = ["mousemove", "mousedown", "touchstart", "keydown", "focus"];
    events.forEach(function (name) {
      el.addEventListener(name, bump, { passive: true });
    });
    bump();
    return function unbind() {
      events.forEach(function (name) {
        el.removeEventListener(name, bump);
      });
      if (timer) {
        clearTimeout(timer);
      }
    };
  }

  return {
    bind: bind,
    bump: bump,
    isActive: function () {
      return active;
    },
    subscribe: function (fn) {
      listeners.push(fn);
      return function () {
        listeners = listeners.filter(function (f) {
          return f !== fn;
        });
      };
    },
    destroy: function () {
      if (timer) {
        clearTimeout(timer);
      }
      listeners = [];
    },
  };
}

export default createActivityMonitor;
